"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagneticShield = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../../cards/Tags");
class MagneticShield {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.MAGNETIC_SHIELD;
        this.description = 'Lose 4 M€ for each Power tag (max 5), then reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.EMPOWER;
        this.currentDelegate = PartyName_1.PartyName.TRANSHUMANS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            let powerTagsCount = Math.min(player.getTagCount(Tags_1.Tags.ENERGY, 'raw'), 5);
            powerTagsCount = Math.max(powerTagsCount - turmoil.getPlayerInfluence(player), 0);
            if (powerTagsCount > 0)
                player.deductResource(Resources_1.Resources.MEGACREDITS, powerTagsCount * 4, { log: true });
        });
    }
}
exports.MagneticShield = MagneticShield;
//# sourceMappingURL=MagneticShield.js.map